import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-page-navi"
}
const _hoisted_2 = { class: "p-page-navi__arrow" }
const _hoisted_3 = { class: "p-page-navi__ol" }
const _hoisted_4 = {
  key: 0,
  class: "p-page-navi__ol__col p-page-navi__ol__col--after"
}
const _hoisted_5 = { class: "p-page-navi__arrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_ButtonMain = _resolveComponent("ButtonMain")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!

  return (_ctx.pageNaviList)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.prevButtonTag), _mergeProps(_ctx.prevButtonTag === 'a' ? { href: _ctx.prevPageUrl } : {}, { class: "p-page-navi__arrow__link" }), {
            default: _withCtx(() => [
              _createVNode(_component_IconBase, {
                class: "p-page-navi__arrow__arrow",
                "view-box": "0 0 24 24",
                width: "24",
                height: "24",
                "icon-color": _ctx.currentPrevLinkColor
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowLeft)
                ]),
                _: 1
              }, 8, ["icon-color"])
            ]),
            _: 1
          }, 16))
        ]),
        _createElementVNode("ol", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageNaviList, (val, key) => {
            return (_openBlock(), _createElementBlock("li", {
              key: key,
              class: "p-page-navi__ol__item"
            }, [
              _createVNode(_component_ButtonMain, {
                tag: _ctx.currentPage === val ? 'div' : 'a',
                href: 
            _ctx.currentPage === val
              ? ''
              : _ctx.baseUrl +
                '&' +
                _ctx.pageParam +
                '=' +
                val +
                _ctx.searchParams +
                _ctx.orderingParam
          ,
                kind: "square",
                "gray-out": _ctx.currentPage !== val,
                style: _normalizeStyle(
            _ctx.currentPage === val
              ? {
                  cursor: 'text',
                  color: '#ffffff',
                  backgroundColor: _ctx.colorCode,
                  border: 'none'
                }
              : ''
          )
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(val), 1)
                ]),
                _: 2
              }, 1032, ["tag", "href", "gray-out", "style"]),
              (key === 1 && val <= _ctx.arrayPosition.maxPage - 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "p-page-navi__ol__col__dot" }, "...", -1)),
                    _createVNode(_component_ButtonMain, {
                      tag: "a",
                      href: 
              _ctx.baseUrl +
                '&' +
                _ctx.pageParam +
                '=' +
                _ctx.maxPage +
                _ctx.searchParams +
                _ctx.orderingParam
            ,
                      kind: "square",
                      "gray-out": _ctx.maxPage !== val
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.maxPage), 1)
                      ]),
                      _: 2
                    }, 1032, ["href", "gray-out"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.nextButtonTag), _mergeProps(_ctx.nextButtonTag === 'a' ? { href: _ctx.nextPageUrl } : {}, { class: "p-page-navi__arrow__link" }), {
            default: _withCtx(() => [
              _createVNode(_component_IconBase, {
                class: "p-page-navi__arrow__arrow",
                "view-box": "0 0 24 24",
                width: "24",
                height: "24",
                "icon-color": _ctx.currentNextLinkColor
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconArrowRight)
                ]),
                _: 1
              }, 8, ["icon-color"])
            ]),
            _: 1
          }, 16))
        ])
      ]))
    : _createCommentVNode("", true)
}